<mat-dialog-content class="common-lib-dialog">
  <div mat-dialog-title>{{data.title}}</div>
  <div class="text-1" [innerHTML]="data.msgContent"></div>
  <div class="subMessage" *ngIf="data.subMessage" [innerHTML]="data.subMessage"></div>
  <div class="copy-clipboard" *ngIf="data.copyClipboard">
    <b>Copy to clipboard: </b>
    <a matTooltip="Copy to clipboard" [cdkCopyToClipboard]="data.copyClipboard">
      <i class="material-icons icon">content_copy</i>
    </a>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="common-lib-dialog">
  <button
    mat-button
    mat-dialog-close
    *ngIf="data.type !== 'information' && !data.reverseBtn && data.cancelText"
    class="btn-cancel"
  >
    {{data.cancelText}}
  </button>
  <button
    mat-flat-button
    mat-dialog-close="true"
    [ngClass]="data.reverseBtn ? 'btn-cancel' : 'btn-ok'"
  >
    {{data.okText}}
  </button>
  <button
    mat-button
    mat-dialog-close
    *ngIf="data.reverseBtn"
    [ngClass]="data.reverseBtn ? 'btn-ok' : 'btn-cancel'"
  >
    {{data.cancelText}}
  </button>
</mat-dialog-actions>
